export default __webpack_public_path__ + "static/media/offer-rejected.185307de.svg";